import { useQuery } from '@tanstack/react-query';

import fetchLotsByIds from '../api/fetchLotsByIds';

/**
 * Lot lookup by ids, e.g. a traveler's installed bags — not cached, so
 * quarantine badges stay current.
 */
export default function useLotsByIds(lotIds) {
  return useQuery({
    queryKey: ['lotsByIds', [...(lotIds || [])].sort()],
    queryFn: () => fetchLotsByIds(lotIds),
    enabled: !!lotIds?.length,
  });
}
